import React from "react";
import Rodape from "./components/Rodape";
import AppState from "./model/AppState";
import ListaModel from "./model/ListaModel";
import ObaTextField from "./components/ObaTextField";
import LogUtil from "./util/LogUtil";
import NavegadorUtil from "./util/NavegadorUtil";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";

import { ReactComponent as ImagemConteudo } from "./assets/images/icons/ico-conteudo-favoritado.svg";
import { ReactComponent as ImagemAdicionar } from "./assets/images/icons/plus-circle.svg";
import Carregando from "./components/Carregando";

interface IListasProps extends RouteComponentProps {}

type ListasState = {
  showNovaListaForm: boolean;
  showMenuForm: boolean;
  listas: ListaModel[];
  carregando: boolean;
  concluido: boolean;
};

class Listas extends React.Component<IListasProps, ListasState> {
  private nomeLista: string = "";

  constructor(props: IListasProps) {
    super(props);

    this.showNovaListaForm = this.showNovaListaForm.bind(this);
    this.showMenuForm = this.showMenuForm.bind(this);
    this.saveLista = this.saveLista.bind(this);

    this.state = {
      showNovaListaForm: false,
      showMenuForm: false,
      listas: [],
      carregando: false,
      concluido: false,
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Listas");
    this.setState({ carregando: true });
    AppState.getListas().then((listas: ListaModel[]) => {
      this.setState({ listas, carregando: false, concluido: true });
    });
  }

  showNovaListaForm(): void {
    this.setState({ showNovaListaForm: !this.state.showNovaListaForm });
  }

  showMenuForm(): void {
    this.setState({ showMenuForm: !this.state.showMenuForm });
  }

  saveLista(): void {
    this.setState({ carregando: true });
    AppState.addLista(this.nomeLista).then((l: ListaModel | null) => {
      this.showNovaListaForm();
      if (l) {
        NavegadorUtil.alerta(this, "Lista criada com sucesso");
        AppState.getListas().then((listas: ListaModel[]) => {
          this.setState({
            listas,
            carregando: false,
          });
        });
      } else {
        this.setState({
          carregando: false,
        });
      }
    }).catch((ex) => {
      NavegadorUtil.alerta(this, ex.message);
      this.setState({
        carregando: false,
      });
    });
  }

  render(): any {
    const { carregando, listas, concluido } = this.state;

    return (
      <section className="lists">
        <div className="header">
          <p className="title">Listas</p>
          <button onClick={this.showMenuForm}>
            <i className="icon fas fa-ellipsis-v"></i>
          </button>
          {this.state.showMenuForm && (
            <div className="floater">
              <div className="item">
                <Link to={NavegadorUtil.getUrl("/listas-excluir")}>
                  Excluir
                </Link>
              </div>
            </div>
          )}
        </div>
        <ul className="arrow-list">
          <li
            className="saved"
            onClick={() =>
              NavegadorUtil.redirect(
                "/dicas-receitas-salvas",
                this.props.history
              )
            }
          >
            <div>
              <ImagemConteudo />
              <span>Dicas e receitas salvas</span>
            </div>
            <div className="more">&gt;</div>
          </li>
          {listas.map((lista: ListaModel) => (
            <li
              key={lista.listaId}
              onClick={() =>
                NavegadorUtil.redirect(
                  `/lista?listaId=${lista.listaId}`,
                  this.props.history
                )
              }
            >
              <div>{lista.nome}</div>
              <div className="more">&gt;</div>
            </li>
          ))}
          {!this.state.showNovaListaForm && (
            <li onClick={this.showNovaListaForm}>
              <div>
                <p>
                  + <span>Criar nova lista</span>
                </p>
              </div>
              <div className="more">&nbsp;</div>
            </li>
          )}
          {this.state.showNovaListaForm && (
            <li>
              <ObaTextField
                className="txt"
                variant="outlined"
                margin="dense"
                label="Informe o nome da lista"
                onChange={(e) => (this.nomeLista = e.target.value)}
              ></ObaTextField>
              <button onClick={this.saveLista}>
                <ImagemAdicionar />
              </button>
            </li>
          )}
        </ul>
        <Rodape parent={this} ativo="Lista"></Rodape>
        <Carregando exibir={carregando} concluido={concluido}></Carregando>
      </section>
    );
  }
}

export default withRouter(Listas);
